// extracted by mini-css-extract-plugin
export default {"line":"Line_line__IcNhF","marquee":"Line_marquee__bgV7k","scroll":"Line_scroll__BGoZy"};